import React, { useContext } from 'react';
import { ReservationContext } from '../../context/ReservationProvider';
import BookingWidget from './components/BookingWidget';

const Reservation: React.FC = () => {
    const { widget } = useContext(ReservationContext);
    if (!widget) return null;

    return (
        <div className="min-h-screen">
            <BookingWidget widgetCode={widget.widget_code} title={widget.name} />
        </div>
    );
};

export default Reservation;
